import React, { FunctionComponent } from "react";
import { MuiThemeProvider, Table, TableCell, TableRow, Typography } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import { useTableStyles } from "../../useTableStyle";
import { ThemeProvider } from "@mui/material/styles";

interface BillProps {
  suspendedBills: any;
  getBillDetails: (tabValue: number, docNo: number) => void;
  listType: string;
}
export const SuspendedBills: FunctionComponent<BillProps> = ({
  suspendedBills,
  getBillDetails,
  listType
}) => {
  const getMuiTheme = useTableStyles();

  const columns = [
    "Bill Doc No",
    "Total Amount",
    "Suspended Time",
    "Created By",
    "Status",
  ];

  const options = {
    selectableRows: undefined,
    selectableRowsHeader: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: true,
      yAxis: true,
    },
    isRowSelectable: function () {
      return false;
    },
    customRowRender: (data: any) => {
      return (
        <TableRow
          style={{ backgroundColor: data[4] == "suspended" ? "white" : "rgb(171 181 192)", cursor: "pointer" }}
          onClick={() => { getBillDetails(1, data[0]) }}
        >
          <TableCell>
            <Typography style={{
              fontSize: "15px",
              fontWeight: "bold"
            }}>{data[0]}</Typography>
          </TableCell>
          <TableCell>
            <Typography style={{
              fontSize: "15px",
              fontWeight: "bold"
            }}>{data[1]}</Typography>
          </TableCell>
          <TableCell>
            <Typography style={{
              fontSize: "15px",
              fontWeight: "bold"
            }}>{data[2]}</Typography>
          </TableCell>
          <TableCell>
            <Typography style={{
              fontSize: "15px",
              fontWeight: "bold"
            }}>{data[3]}</Typography>
          </TableCell>
          <TableCell>
            <Typography style={{
              fontSize: "15px",
              fontWeight: "bold",
            }}>{data[4]}</Typography>
          </TableCell>
        </TableRow>
      );
    }
  };

  return (
    <Table>
      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          title={listType === "currentday" ? "Suspended and Resumed Bill List" : "Suspended bill List"}
          data={suspendedBills.suspended_bills?.map((bill: any) => {
            return [
              bill.suspendend_bill_doc_number,
              bill.bill_total_amount,
              moment(bill.suspended_time).format("DD/MM/YYYY  h:mm:ss A"),
              bill.created_by,
              bill.status
            ];
          })}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </Table>
  );
};
